import { render, staticRenderFns } from "./companyTabList.vue?vue&type=template&id=0bc70604&"
import script from "./companyTabList.vue?vue&type=script&lang=js&"
export * from "./companyTabList.vue?vue&type=script&lang=js&"
import style0 from "./companyTabList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports